import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from '@mui/material';
import {estilos} from './estilos'

export default function InputCheckbox(props) {
    const classes = estilos(props);
    return (
      <>
        {props.showInputCheckox && (
          <FormControl className={classes.formControl} component="fieldset">
            <FormLabel component="legend">{props.label}</FormLabel>
                <FormGroup
                    name={props.idelement}
                    value={props.value}
                    className={classes.radioGroup}
                    onChange={(e) => {
                      const elemento = props.options?.find( ({value}) => Number(value) === Number(e.target.value));
                      props.handleCheckbox(e, elemento, props.value)
                    }} >
                    {props.options?.map( ({value, label, checkeado}) => (
                        <FormControlLabel
                            key={value}
                            value={value}
                            control={<Checkbox checked={checkeado} />}
                            label={label}
                            className={classes.elementGroupClasses}
                            name={props.idelement}
                        />
                    ))
                    }
                </FormGroup>
                {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
          </FormControl>
        )}
      </>
    )
}

InputCheckbox.defaultProps = {
  showInputCheckox: true,
  label: ""
}